<template>
  <div>
    <el-dialog title="详情" :visible.sync="dialogVisible" :close-on-click-modal="false" @closed="onClose" width="1000px">
      <el-descriptions :column="2" size="mini" border :label-style="{width: '120px'}" :content-style="{width: 'calc(45% - 400px)'}">
        <el-descriptions-item label="项目名称">
          {{formData.project_name}}
        </el-descriptions-item>
        <el-descriptions-item label="单位名称">
          <!--        <el-input v-model="formData.company_name" size="mini" clearable></el-input>-->
          <el-select v-model="formData.company_id" class="m-2" filterable placeholder="选择单位" clearable size="mini">
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="负责人">
          <el-input v-model="formData.head_name" size="mini" clearable style="width: 300px;"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="负责人电话">
          <el-input v-model="formData.telephone" size="mini" clearable style="width: 300px;"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="对接人">
          <el-input v-model="formData.contact_name" size="mini" clearable style="width: 300px;"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="对接人电话">
          <el-input v-model="formData.contact_telephone" size="mini" clearable style="width: 300px;"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="合同附件">
          <el-row>
            <el-col :span="12">
              <el-link type="primary" @click="uploadFile(formData,'contact_file')">上传证件</el-link>
            </el-col>
            <el-col :span="12">
              <el-link type="primary" v-if="formData.contact_file" @click="viewFile(formData,'contact_file')">查看证件</el-link>
            </el-col>
          </el-row>
        </el-descriptions-item>
        <el-descriptions-item label="--">

        </el-descriptions-item>
        <el-descriptions-item label="收款账户">
          <el-input v-model="formData.bank_card" size="mini" clearable style="width: 300px;"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="开户行">
          <el-input v-model="formData.bank_name" size="mini" clearable style="width: 300px;"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="在管-服务费率(%)">
          <el-input v-model="formData.online_service_rate" size="mini" clearable style="width: 300px;"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="在管-诉讼费率(%)">
          <el-input v-model="formData.online_ss_service_rate" size="mini" clearable style="width: 300px;"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="撤场-服务费率(%)">
          <el-input v-model="formData.offline_service_rate" size="mini" clearable style="width: 300px;"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="撤场-诉讼费率(%)">
          <el-input v-model="formData.offline_ss_service_rate" size="mini" clearable style="width: 300px;"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="合同时间">
          <el-date-picker style="width: 150px;"
                          v-model="formData.start_time"
                          type="date"
                          size="mini"
                          value-format="yyyy-MM-dd"
                          clearable
          />
          <el-date-picker style="width: 150px;"
                          v-model="formData.end_time"
                          type="date"
                          size="mini"
                          value-format="yyyy-MM-dd"
                          clearable
          />
        </el-descriptions-item>
        <el-descriptions-item label="合作签订时间">
          <el-date-picker style="width: 300px;"
                          v-model="formData.execution_date"
                          type="date"
                          size="mini"
                          value-format="yyyy-MM-dd"
                          clearable
          />
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-select v-model="formData.status" class="m-2" filterable placeholder="选择状态" clearable size="mini">
            <el-option
              v-for="item in [{name:'终止合作',value:0},{name:'合作中',value:1}]"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          <el-input v-model="formData.remark" size="mini" clearable style="width: 300px;"></el-input>
        </el-descriptions-item>
      </el-descriptions>

      <template #footer>
        <div style="">
          <el-button size="mini" @click="dialogVisible=false">取消</el-button>
          <el-button size="mini" @click="save">确认</el-button>
        </div>
      </template>
    </el-dialog>
    <ViewFileList ref="viewFileListRef" />
  </div>

</template>

<script>
import ButlerHttp from "../../../common/ButlerHttp";
import ViewFileList from "../../../../Common/ViewFileList";

export default {
  name: "CompanyProjectEditor",
  components: {ViewFileList},
  data() {
    return {
      formData:{
        id:"",
        company_id:"",
        project_id:"",
        project_name:"",
        start_time: "",
        end_time: "",
        execution_date: "",
        contact_name: "",
        contact_telephone: "",
        contact_file: "",
        bank_card: "",
        bank_name: "",
        online_service_rate: "",
        online_ss_service_rate: "",
        offline_service_rate: "",
        offline_ss_service_rate: "",
        operate_id: "",
        operate_name: "",
        status: 1,
        created_at: "",
        updated_at: ""
      },
      dialogVisible:false,
      callback:null,
      companyList: [],
    }
  },
  methods:{
    show(data,callback){
      this.dialogVisible = true;
      this.getCompanyList();
      this.formData = this.getFromData(data);
      this.callback = callback;
    },
    onClose(){
      this.dialogVisible = false;
      this.formData = this.getFromData({});
    },
    getFromData(fromData){
      return Object.assign({
        id:'',
        company_id:"",
        project_id:"",
        project_name:"",
        start_time: "",
        end_time: "",
        execution_date: "",
        contact_name: "",
        contact_telephone: "",
        contact_file: "",
        bank_card: "",
        bank_name: "",
        online_service_rate: "0.00",
        online_ss_service_rate: "0.00",
        offline_service_rate: "0.00",
        offline_ss_service_rate: "0.00",
        operate_id: "",
        operate_name: "",
        status: 1,
        sort:"",
        created_at: "",
        updated_at: ""
      },fromData);
    },
    getCompanyList(){
      const that = this;
      ButlerHttp.post("ThirdPartyCommon/getCompanyList", {}, res => {
        if (res.code) {
          that.companyList = res.data;
        }
      });
    },
    save(){
      const that = this;
      that.loading = true;
      let formData = ERP.reJson(that.formData)
      ButlerHttp.post("ProjectCollectionThridCompanyProjectContract/save", formData, res => {
        if (res.code) {
          that.dialogVisible = false;
          typeof that.callback == 'function' && that.callback();
        } else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    },
    save2(){
      const that = this;
      that.loading = true;
      let formData = ERP.reJson(that.formData)
      ButlerHttp.post("ProjectCollectionThridCompanyProjectContract/save", formData, res => {
        if (res.code) {
          typeof that.callback == 'function' && that.callback();
        } else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    },
    uploadFile(item,name){
      const that=this;
      that.$refs.viewFileListRef.UploadFile(data=>{
        item[name]=data.FileID
        that.save2();
      },item[name]);
    },
    viewFile(item,name){
      const that=this;
      that.$refs.viewFileListRef.show(item[name])
      that.$refs.viewFileListRef.onList(list=>{
        if(list.length===0){
          item[name]="";
          that.save2();
        }
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty_common/components/CompanyProjectEditor.vue